export default function (state = null, action) {
    switch (action.type) {
      case 'MARK_SPOT_URL':
          return {
            last_url: action.payload
          };
          break;

      default:
          return {
            last_url: "",
          }
          break;
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/services/markSpot/reducer.js